import { useState } from "react";
import { api } from "../../../../../../../utility/api";
import { transformRecepcion } from "../../../helpers/data";

const transformTraslado = (traslado) => {
    return {
        ...traslado,
        detalles: traslado.detalles.map((detalle) =>
            transformRecepcion(detalle),
        ),
    };
};

const transformTraslados = (response) => {
    const { count, results } = response;

    const data = results.map((item) => transformTraslado(item));

    return { count, results: data };
};

export const ListadoTrasladosApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTraslados = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("traslados", params);
            return transformTraslados(response);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarTraslado = async (id, body) => {
        try {
            setCargando(true);
            const response = await api.patch(`traslados/${id}`, body);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getTrasladosFinalizados = async (params) => {
        try {
            setCargando(true);
            // El traslado viene solo con id y número; el detalle se pide al abrir el modal
            return await api.get("traslados/traslados-finalizados", params);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getTrasladosProceso = async (params) => {
        try {
            setCargando(true);
            // El traslado viene solo con id y número; el detalle se pide al abrir el modal
            return await api.get("traslados/traslados-proceso", params);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarTrasladoPendiente = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(`traslados/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTraslados,
        actualizarTraslado,
        getTrasladosFinalizados,
        getTrasladosProceso,
        eliminarTrasladoPendiente,
        
        cargando,
    };
};
